module.exports = __webpack_public_path__ + "img/404.f0d44c6f.png";